// extracted by mini-css-extract-plugin
module.exports = {"root":"Labeled_root__3swC5","label":"Labeled_label__1aCnf","divider":"Labeled_divider__2Y2Kr"};